
import React from "react";
import styled from "styled-components";

import Title from "../title";
import Article from "../article";

const VehiculeSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    clip-path: polygon(100px 0, 100% 0, 100% calc(100% - 100px), calc(100% - 100px) 100%, 0 100%, 0 100px);
    margin-top: -100px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.75);
    border: 6px solid #fafafa;
    padding-top: 50px;
    padding-bottom: 200px;
    position: absolute;
    top: 0;
    z-index: 99;
`;

const VehiculesSection = () => {
    return (
        <div style={{
            position: 'relative',
            width: '100%',
            height: '295px'
        }}>
            <VehiculeSectionContainer>
                <Title text={'Véhicules'} />
                <Article>
                    Transferts aéroport-stations de ski en VTC :<br/>
                    confort, sécurité et service sur-mesure pour un voyage serein.
                </Article>
            </VehiculeSectionContainer>
        </div>
    );
}

export default VehiculesSection;